/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import { SERVER_URL } from '../../../config';

import Tooltip from '../../common/Tooltip';

export default class WeekView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventWidth: 0,
            open: false,
        };
    }

    render() {
        const { event } = this.props;
        let statusClass =
            event.bookings.length == 0 && event.status == 'PA'
                ? 'CA'
                : event.status;
        let description =
            event.bookings.length == 0 && event.status == 'PA'
                ? 'Cancelled'
                : event.status == 'OP'
                ? 'Open'
                : event.status == 'CF'
                ? 'Confirmed'
                : event.status == 'CP'
                ? 'Completed'
                : event.status == 'PA'
                ? 'Paid'
                : event.status == 'MP'
                ? 'Paid'
                : event.status == 'IC'
                ? 'In checkout'
                : event.status == 'OB'
                ? 'Open for backups'
                : event.status == 'CA'
                ? 'Cancelled'
                : '';

        if (event.status == 'OE') {
            description = 'OE';
            statusClass = 'NS';
        }

        const {
            service_key,
            vehicle_type,
            role,
            client_full = null,
            address1,
        } = event;
        let icon;
        switch (service_key) {
            case 'driver':
                if (vehicle_type == '4') {
                    icon = 'vespa';
                } else if (vehicle_type == '2') {
                    icon = 'car-10';
                } else if (vehicle_type == '1') {
                    icon = 'food-truck';
                }
                break;
            case 'hospitality':
                if (role == 'WA') {
                    icon = 'food-dome-serving-1';
                } else if (role == 'BM') {
                    icon = 'cocktail';
                } else if (role == 'BT') {
                    icon = 'barista';
                } else if (role == 'MX') {
                    icon = 'chef-hat';
                } else if (role == 'KP') {
                    icon = 'muscle';
                }
                break;
            default:
                icon = 'help-circle';
        }

        const maxSlots = event.number_of_freelancers;
        const workerNumber = event.bookings.length;
        const startTime = moment(event.start).format('HH:mm');
        const endTime = moment(event.end).format('HH:mm');
        return (
            <div className="week-event-container">
                <Tooltip
                    tooltip={
                        <span>
                            <p>{`${startTime} - ${endTime}`}</p>
                            {client_full ? (
                                <p>Client: {client_full.company_name}</p>
                            ) : null}
                            <p>{address1}</p>
                            <p>{`${workerNumber}/${maxSlots} positions filled`}</p>
                        </span>
                    }
                >
                    <div className="week-event">
                        <div className="week-event__title">
                            <i
                                className={`icon icon-${icon} icon-${
                                    service_key == 'driver'
                                        ? `d${vehicle_type}`
                                        : role
                                }`}
                            />
                            <span className="margin-left">
                                <a href={`${SERVER_URL}/job/${event.id}`}>
                                    {event.reference_number}
                                </a>
                            </span>
                            <div
                                style={{
                                    minHeight: '1rem',
                                    zIndex: 0,
                                }}
                                className={`rt-status-cell bullet bullet-left bullet-status-${statusClass}`}
                            />
                        </div>

                        <div className="week-event__bookings">
                            {renderBookings(event)}
                        </div>
                    </div>
                </Tooltip>
            </div>
        );
    }
}

function renderBookings(event) {
    const maxSlots = event.number_of_freelancers;
    const workerList = event.bookings.map(booking => (
        <Tooltip
            tooltip={booking.freelancer_detail.full_name}
            key={booking.freelancer_detail.id}
        >
            <div
                className="week-event__bookings--photo"
                style={{
                    backgroundImage: `url(${booking.freelancer_detail.photo_thumbnail_medium})`,
                    backgroundSize: 'cover',
                }}
            />
        </Tooltip>
    ));
    let id = 1;
    while (workerList.length < maxSlots) {
        workerList.push(
            <Tooltip key={`${event.id}slot${id}`} tooltip="Unfilled position">
                <div
                    className="week-event__bookings--photo"
                    style={{
                        border: '2px dashed #e3e3e3',
                    }}
                />
            </Tooltip>,
        );
        id++;
    }
    return workerList;
}
